module.exports = __webpack_public_path__ + "img/fe_backdrop_invasion.3cffa95c.png";